import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { Button } from "antd";
import AddIcon from "@mui/icons-material/Add";
import firebase from "../../../config/firebase";
import NewMiniDrawer from "../../../components/navMenu/menu-nav";
import DataMdfeCompTable from "../../../components/Data-mdf-table/data-mdfe-table";
import "./css/list-mdf-e.css";
require("firebase/auth");

function MdfeListView() {
    const db = firebase.firestore();

    var userLogado = useSelector((state) => state.usuarioLogado);
    const user = useSelector((state) => state.user);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        let mounted = true;
        const db = firebase.firestore();

        const load = async () => {
            if (!mounted) return;
            setLoading(true);
            try {
            const mdfeList = [];

            if (user?.viewALL) {
                // busca todos os documentos
                const result = await db.collection("tb_mdfe").get();
                if (!mounted) return;
                result.docs.forEach((doc) => mdfeList.push({ id: doc.id, ...doc.data() }));
                setData(mdfeList);
            } else {
                // monta uids: uidShipperAffiliates + uidShipper (sem duplicatas)
                const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
                const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
                const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

                if (uids.length === 1) {
                    const res = await db.collection("tb_mdfe")
                        .where("infMDFe.dataOrigin.idShipper", "==", uids[0])
                        .get();
                    if (!mounted) return;
                    res.docs.forEach((doc) => mdfeList.push({ id: doc.id, ...doc.data() }));
                    setData(mdfeList);
                } 
                else {
                    const res = await db.collection("tb_mdfe")
                        .where("infMDFe.dataOrigin.idShipper", "in", uids)
                        .get();
                    if (!mounted) return;
                    res.docs.forEach((doc) => mdfeList.push({ id: doc.id, ...doc.data() }));
                    setData(mdfeList);
                }
            }
            } catch (error) {
                console.error("Erro ao carregar MDF-e:", error);
                if (mounted) setData([]);
            } finally {
                if (mounted) setLoading(false);
            }
        };

        load();

        return () => {
            mounted = false;
        };
    }, [user]);

    return (
        <>
        {useSelector((state) => state.usuarioLogado) > 0 ? (
            <NewMiniDrawer
            divOpen={
                <div className="freight-content">
                <div className="page-header">
                    <h4 className="page-title">Lista de MDF-e</h4>
                </div>

                <div className="table-container">
                    <DataMdfeCompTable listMdfe={data} />
                </div>
                </div>
            }
            />
        ) : (
            <Navigate to="/login" />
        )}
        </>
    );
}

export default MdfeListView;
